import React, { useCallback, useImperativeHandle, useState } from 'react'
import RoundedModal from '../../../../../../molecules/RoundedModal'
import ReplaceFeeScheduleForm from './form'

const ReplaceFeeScheduleDialog = React.forwardRef(function ReplaceFeeScheduleDialog (_, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })
  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  useImperativeHandle(ref, () => ({
    open: (client, feeSchedule) => setDialogState({ open: true, processing: false, client, feeSchedule })
  }), [setDialogState])

  return (
    <RoundedModal
      title='Replace Fee Schedule'
      open={dialogState.open}
      onClose={close}
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (<ReplaceFeeScheduleForm client={dialogState.client} feeSchedule={dialogState.feeSchedule} onComplete={close} onCancel={close} />) : null}
      </div>
    </RoundedModal>
  )
})

ReplaceFeeScheduleDialog.propTypes = {
}

export default ReplaceFeeScheduleDialog
